<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-flex text-center>
            <v-img
                :src="require('@/assets/images/check-out.svg')"
                class="d-inline-flex mb-8"
            ></v-img>
            <div class="common-text text-center">
                {{ message }}
            </div>
        </v-flex>
    </v-container>
</template>

<script>
export default {
    name: 'FinalPage',
    data() {
        return {
            message: null,
        };
    },
    created() {
        if (this.$route.params.message) {
            this.message = this.$route.params.message;
        } else {
            this.checkToken();
        }
    },
    methods: {
        checkToken() {
            this.$http.get('/hotels/guest/profile/')
                .then(() => {
                    this.$router.push({ name: "devicelist" });
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.code == "access_key_expiration_date_has_expired") {
                        this.message = error.response.data.message;
                    }
                });
        },
    },
}
</script>